import { OperatingSystem } from '../../types/OperatingSystem.type'

function getOperatingSystem(): OperatingSystem {
  const userAgent = navigator.userAgent
  const platform = navigator.platform

  if (/Windows/.test(platform) || /Windows/.test(userAgent)) {
    return OperatingSystem.WINDOWS
  } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(platform)) {
    return OperatingSystem.MAC_OS
  } else if (
    /iPhone|iPad|iPod/.test(platform) ||
    /iPhone|iPad|iPod/.test(userAgent)
  ) {
    return OperatingSystem.IOS
  } else if (/Android/.test(userAgent)) {
    return OperatingSystem.ANDROID
  } else if (/Linux/.test(platform)) {
    return OperatingSystem.LINUX
  } else {
    return OperatingSystem.UNKNOWN
  }
}

export { getOperatingSystem }
